"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _serializr = require("serializr");
var _utils = require("@seedlang/utils");
var _root_model = _interopRequireDefault(require("./root_model"));
var _concept_basic = _interopRequireDefault(require("./concept_basic"));
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var PRONOUN_FIELDS = [{
  field: 'singular1p',
  hideField: 'hideSingular1p',
  pronoun: 'singular_1p'
}, {
  field: 'singular2p',
  hideField: 'hideSingular2p',
  pronoun: 'singular_2p'
}, {
  field: 'singular3p',
  hideField: 'hideSingular3p',
  pronoun: 'singular_3p'
}, {
  field: 'plural1p',
  hideField: 'hidePlural1p',
  pronoun: 'plural_1p'
}, {
  field: 'plural2p',
  hideField: 'hidePlural2p',
  pronoun: 'plural_2p'
}, {
  field: 'plural3p',
  hideField: 'hidePlural3p',
  pronoun: 'plural_3p'
}];
var ConjugatedVerbString = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_concept_basic["default"])), _class = /*#__PURE__*/function (_RootModel) {
  function ConjugatedVerbString() {
    var _this;
    _classCallCheck(this, ConjugatedVerbString);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ConjugatedVerbString, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "singular1p", _descriptor2, _this);
    _initializerDefineProperty(_this, "singular2p", _descriptor3, _this);
    _initializerDefineProperty(_this, "singular3p", _descriptor4, _this);
    _initializerDefineProperty(_this, "plural1p", _descriptor5, _this);
    _initializerDefineProperty(_this, "plural2p", _descriptor6, _this);
    _initializerDefineProperty(_this, "plural3p", _descriptor7, _this);
    _initializerDefineProperty(_this, "hideSingular1p", _descriptor8, _this);
    _initializerDefineProperty(_this, "hideSingular2p", _descriptor9, _this);
    _initializerDefineProperty(_this, "hideSingular3p", _descriptor0, _this);
    _initializerDefineProperty(_this, "hidePlural1p", _descriptor1, _this);
    _initializerDefineProperty(_this, "hidePlural2p", _descriptor10, _this);
    _initializerDefineProperty(_this, "hidePlural3p", _descriptor11, _this);
    _initializerDefineProperty(_this, "showFeminine", _descriptor12, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor13, _this);
    _initializerDefineProperty(_this, "conceptId", _descriptor14, _this);
    _initializerDefineProperty(_this, "concept", _descriptor15, _this);
    return _this;
  }
  _inherits(ConjugatedVerbString, _RootModel);
  return _createClass(ConjugatedVerbString, [{
    key: "singular1pDisplay",
    get: function get() {
      if (this.hideSingular1p) {
        return '-';
      }
      if (this.showFeminine && this.languageId == 'FR') {
        return "".concat(this.singular1p, "(e)");
      }
      return this.singular1p;
    }
  }, {
    key: "singular2pDisplay",
    get: function get() {
      if (this.hideSingular2p) {
        return '-';
      }
      if (this.showFeminine && this.languageId == 'FR') {
        return "".concat(this.singular2p, "(e)");
      }
      return this.singular2p;
    }
  }, {
    key: "singular3pDisplay",
    get: function get() {
      if (this.hideSingular3p) {
        return '-';
      }
      if (this.showFeminine && this.languageId == 'FR') {
        return "".concat(this.singular3p, "(e)");
      }
      return this.singular3p;
    }
  }, {
    key: "plural1pDisplay",
    get: function get() {
      if (this.hidePlural1p) {
        return '-';
      }
      if (this.showFeminine && this.languageId == 'FR') {
        return this.plural1p.replace(/s$/, '(e)s');
      }
      return this.plural1p;
    }
  }, {
    key: "plural2pDisplay",
    get: function get() {
      if (this.hidePlural2p) {
        return '-';
      }
      if (this.showFeminine && this.languageId == 'FR') {
        return this.plural2p.replace(/s$/, '(e)s');
        ;
      }
      return this.plural2p;
    }
  }, {
    key: "plural3pDisplay",
    get: function get() {
      if (this.hidePlural3p) {
        return '-';
      }
      if (this.showFeminine && this.languageId == 'FR') {
        return this.plural3p.replace(/s$/, '(e)s');
        ;
      }
      return this.plural3p;
    }
  }, {
    key: "hasAvailablePronouns",
    get: function get() {
      var _this2 = this;
      return PRONOUN_FIELDS.some(function (_ref) {
        var field = _ref.field,
          hideField = _ref.hideField;
        return !_this2[hideField] && (0, _utils.isPresent)(_this2[field]);
      });
    }
  }, {
    key: "availablePronouns",
    get: function get() {
      var _this3 = this;
      return PRONOUN_FIELDS.filter(function (_ref2) {
        var field = _ref2.field,
          hideField = _ref2.hideField;
        return !_this3[hideField] && (0, _utils.isPresent)(_this3[field]);
      }).map(function (_ref3) {
        var pronoun = _ref3.pronoun;
        return pronoun;
      });
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "singular1p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "singular2p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "singular3p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "plural1p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "plural2p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "plural3p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "hideSingular1p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "hideSingular2p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "hideSingular3p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "hidePlural1p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "hidePlural2p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "hidePlural3p", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "showFeminine", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "conceptId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "concept", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "singular1pDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "singular1pDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "singular2pDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "singular2pDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "singular3pDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "singular3pDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "plural1pDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "plural1pDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "plural2pDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "plural2pDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "plural3pDisplay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "plural3pDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasAvailablePronouns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasAvailablePronouns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "availablePronouns", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "availablePronouns"), _class.prototype), _class);
var _default = exports["default"] = ConjugatedVerbString;